export const updateDefaultFieldsArray = ({
  tableData,
  removeList = [],
  options = [],
  order = [],
  initialState = [],
}) => {
  const initialArray = [...initialState];

  if (tableData?.length > 0) {
    const currentData = tableData[0];
    for (let key in currentData) {
      if (!initialArray.find((data) => data?.value == key)) {
        let title = String(key).split("_").join(" ").toUpperCase();
        const obj = {
          id: Math.floor(Math.random() * 10000),
          title: title,
          value: key,
          width: String(title)
            .split(" ")
            .find((titleData) => titleData.length > 11)
            ? "max-w-[12rem]"
            : "max-w-[8rem]",
          hide: true,
        };
        initialArray.push(obj);
      }
    }
  }

  const removeListArray = ["id", "created_at", "updated_at", ...removeList];
  const filteredArray = initialArray.filter(
    (data) => !removeListArray.includes(data.value)
  );

  const defaultTrueArray = filteredArray.map((item) => {
    if (order.includes(item.value))
      return { ...item, default: true, hide: false };
    else return { ...item, default: false };
  });
  const mappedArray = defaultTrueArray.map((item) => {
    const optionItem = options.find(
      (option) =>
        option.value === item.value ||
        new RegExp(`^${option.startingWith}`).test(item.value)
    );

    if (optionItem) {
      // Merge properties from optionItem into the current item
      return { ...item, ...optionItem, value: item.value };
    }

    return item;
  });

  const removedHidedData = mappedArray.filter((data) => !data?.hide);

  const sortedArray = removedHidedData.sort((a, b) => {
    const aValue = order.indexOf(a.value);
    const bValue = order.indexOf(b.value);
    // Handle the case where a value is not present in orderArray
    if (aValue === -1 && bValue === -1) {
      return 0; // No change in order for values not in orderArray
    } else if (aValue === -1) {
      return 1; // Move items not in orderArray to the end
    } else if (bValue === -1) {
      return -1; // Move items not in orderArray to the end
    }
    return aValue - bValue;
  });

  return sortedArray;
};
